// Generic-pair props for the GLOBAL programmes catalog picker — flat rows
// (`should_serialize=false` → no JSON:API envelope, hence explicit accessors).
// Spread into APMultiSelect / APFormCombobox / APFormMultiSelect:
//   <APFormCombobox {...useProgrammesSelect()} name="programme_id" … />
// Extract-on-second-consumer: tags form + tags filters + orgs filters.
// Org-scoped programme options (org_programmes) are useOrgProgrammeSelect.
import type { CrudFilter } from '@refinedev/core';

export interface ProgrammesSelectProps {
  resource: 'programmes';
  optionLabel: string;
  optionValue: string;
  filters: CrudFilter[];
  pageSize: number;
}

const PROGRAMMES_SELECT_PROPS: ProgrammesSelectProps = {
  resource: 'programmes',
  optionLabel: 'name',
  optionValue: 'id',
  filters: [{ field: 'should_serialize', operator: 'eq', value: false }],
  pageSize: 50,
};

export const useProgrammesSelect = (): ProgrammesSelectProps => PROGRAMMES_SELECT_PROPS;
